import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

document.addEventListener("click", (event) => {
  if (event.target.tagName == "A") {
    const destination = event.target.getAttribute("href")
    if (destination.startsWith("#")) {
      element = document.getElementById(destination.slice(1))
      element.scrollIntoView({ behavior: "smooth" });
      event.preventDefault()
      return false
    } else if (destination.startsWith(location.pathname + "#")) {
      element = document.getElementById(destination.split("#")[1])
      element.scrollIntoView({ behavior: "smooth" });
      event.preventDefault()
    }
  }
  if (event.target.classList.contains("js-close-cookie-consent")) {
    document.cookie = "cookie_consent=accepted; expires=Fri, 31 Dec 9999 23:59:59 GMT"
    document.querySelector(".cookie-consent").classList.add("hidden")
    window.gtag && window.gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      functionality_storage: 'granted',
      personalization_storage: 'granted'
    });
  }
})

if (document.cookie.split(';').filter((item) => item.includes('cookie_consent=accepted')).length) {
  document.querySelector(".cookie-consent").classList.add("hidden")
} else {
  document.querySelector(".cookie-consent").classList.remove("hidden")
}

window.addEventListener('message', (event) => {
  console.log(event)
});
